import { Cog } from '@procore/core-icons'
import React from 'react'
import { LinkButton } from '../Button'
import { PageHeaderTemplate } from '../PageTemplate/PageHeaderTemplate'
import { PageTemplate } from '../PageTemplate/PageTemplate'
import { Tooltip } from '../Tooltip'
import { useI18nContext } from '../_hooks/I18n'
import type {
  ToolLandingPageHeaderTemplateProps,
  ToolLandingPageTemplateProps,
} from './ToolLandingPageTemplate.types'

export const ToolLandingPageHeaderTemplate = React.forwardRef<
  HTMLDivElement,
  ToolLandingPageHeaderTemplateProps
>(
  (
    { settingsLink, ...headerProps }: ToolLandingPageHeaderTemplateProps,
    ref
  ) => {
    const i18n = useI18nContext()

    const settingsLinkIsString = typeof settingsLink === 'string'

    const settingsButton = settingsLink ? (
      <Tooltip
        overlay={i18n.t('core.toolHeader.settingsAction')}
        trigger={['hover', 'focus']}
      >
        <LinkButton
          aria-label={i18n.t('core.toolHeader.settingsAction')}
          as={settingsLinkIsString ? undefined : settingsLink}
          href={settingsLinkIsString ? settingsLink : '#'}
          icon={<Cog />}
          role="link"
          variant="secondary"
        />
      </Tooltip>
    ) : null

    return (
      <PageHeaderTemplate
        ref={ref}
        beforeTitleZone={settingsButton}
        {...headerProps}
        data-core-react="tool-landing-page-header-template"
      />
    )
  }
)

export const ToolLandingPageTemplate = React.forwardRef<
  HTMLDivElement,
  ToolLandingPageTemplateProps
>(({ children, header, headerProps }: ToolLandingPageTemplateProps, ref) => {
  return (
    <PageTemplate
      data-core-react="tool-landing-page-template"
      header={header ?? <ToolLandingPageHeaderTemplate {...headerProps!} />}
      ref={ref}
    >
      {children}
    </PageTemplate>
  )
})
